export default __webpack_public_path__ + "static/media/seu-trabalho.ac3cefcb.png";